export default "__VITE_ASSET__CCD10nD9__"